import { render, staticRenderFns } from "./FilterTags.vue?vue&type=template&id=1874128d&scoped=true"
import script from "./FilterTags.vue?vue&type=script&lang=js"
export * from "./FilterTags.vue?vue&type=script&lang=js"
import style0 from "./FilterTags.vue?vue&type=style&index=0&id=1874128d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1874128d",
  null
  
)

export default component.exports